module.exports = __webpack_public_path__ + "a28884f59649b744bff95864bd7d2f5a.png";